<div class="selection" [formGroup]="form">
  <label [for]="id">{{ label }}</label>
  <select [ngClass]="invalid ? 'invalid' : ''" [id]="id" formControlName="{{controlName}}">
    <option *ngIf="!disablePlaceHolder" value="">{{ placeHolder }}</option>
    <option [selected]="option.selected" *ngFor="let option of options" [value]="option.key">{{ option.value }}</option>
  </select>
  <ng-content></ng-content>
</div>
